module.exports = __webpack_public_path__ + "img/arrow-left-right.2c09f821.svg";